import { Patient } from '@eql-ai/typescript-types';
import { UserCredential } from 'firebase/auth';
import { Timestamp } from 'firebase/firestore';
import phioActionTypes from './phioActionTypes';
import { PhioReducerAction, RegionData } from './phioRedux.types';

export interface MembershipData {
    memberId: string;
    startDate: Timestamp;
}

export const setAuthState = (
    auth: UserCredential | null,
): PhioReducerAction => {
    return {
        type: phioActionTypes.SET_AUTH_STATE,
        payload: auth,
    };
};

export const setRegionData = (data: RegionData): PhioReducerAction => {
    return {
        type: phioActionTypes.SET_REGION,
        payload: data,
    };
};

export const setMembershipData = (data: MembershipData): PhioReducerAction => {
    return {
        type: phioActionTypes.SET_MEMBERSHIP,
        payload: data,
    };
};

export const setPatientData = (
    patientData: Patient | null,
): PhioReducerAction => {
    return {
        type: phioActionTypes.SET_PATIENT_DATA,
        payload: patientData,
    };
};

export const setIsFirstAttempt = (
    isFirstAttempt: boolean,
): PhioReducerAction => {
    return {
        type: phioActionTypes.SET_IS_FIRST_ATTEMPT,
        payload: isFirstAttempt,
    };
};
